import React from "react";

// Navigate
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { CommissionManageTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

//mui
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fade from "@mui/material/Fade";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

// Mui Icon
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
//moment
import { getRosterByUserIdAndDate } from "@/fetch/fetchRoster";
import moment from "moment";

import {
  createSetting,
  getSettingById,
  updateSetting,
} from "@/fetch/fetchCommission";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getProducts } from "@/fetch/fetchStatistics";
import _ from "lodash";

import AdjustmentFormRow from "@/components/CommisstionSetting/adjustmentFormRow";
import BonusFormRow from "@/components/CommisstionSetting/bonusFormRow";
import CommissionLevelFormRow from "@/components/CommisstionSetting/commissionLevelFormRow";
import MutiLocationFormRow from "@/components/CommisstionSetting/mutiLocationFormRow";
import OnShiftFormRow from "@/components/CommisstionSetting/onShiftFormRow";
import ProductBonusFormRow from "@/components/CommisstionSetting/productBonusFormRow";
import ProductCommissionFormRow from "@/components/CommisstionSetting/productCommissionFormRow";
import SpecialComissionLevelFormRow from "@/components/CommisstionSetting/specialComissionLevelFormRow";
import SpecialShiftFormRow from "@/components/CommisstionSetting/specialShiftFormRow";
import TransferFormRow from "@/components/CommisstionSetting/tranfersFormRow";
import TransferProductCommissionsFormRow from "@/components/CommisstionSetting/transferProductCommissionsFormRow";
moment.updateLocale("zh-hk", {
  weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
});
const CommissionSettingPage = (props) => {
  const { open, setOpen } = props;
  const navigate = useNavigate();

  const { id } = useParams();
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: "none",
    },
  });
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  // const [settings, setSettings] = React.useState([]);
  const [commissionLevelFormData, setCommissionLevelFormData] = React.useState([
    { amount: 50000, percentage: 8 },
    { amount: 50000, percentage: 8 },
    { amount: 5000, percentage: 13.5 },
    { amount: 5000, percentage: 13.75 },
    { amount: 5000, percentage: 14 },
    { amount: 5000, percentage: 14.25 },
    { amount: 5000, percentage: 14.5 },
    { amount: 5000, percentage: 14.75 },
    { amount: 5000, percentage: 15 },
    { amount: 5000, percentage: 15.25 },
    { amount: 5000, percentage: 15.5 },
    { amount: 5000, percentage: 15.75 },
    { amount: 5000, percentage: 16 },
    { amount: 5000, percentage: 16.25 },
    { amount: 5000, percentage: 16.5 },
    { amount: 5000, percentage: 16.75 },
    { amount: 5000, percentage: 17 },
    { amount: 5000, percentage: 17.25 },
    { amount: 5000, percentage: 17.5 },
    { amount: 5000, percentage: 17.75 },
    { amount: 110000, percentage: 18 },
    { amount: 100000, percentage: 18.25 },
    { amount: 100000, percentage: 18.5 },
    { amount: 99999999999, percentage: 18.75 },
  ]);
  const [specialCommissionLevelFormData, setSpecialCommissionLevelFormData] =
    React.useState({
      promoter: [],
      schmea_name: "",
      schmea: [],
    });
  const [commissionLevelValidation, setCommissionLevelValidation] =
    React.useState([]);

  const [
    specialCommissionLevelValidation,
    setSpecialCommissionLevelValidation,
  ] = React.useState([]);
  const [productCommissionFormData, setProductCommissionFormData] =
    React.useState(
      Array(0).fill({
        productIds: [],
      })
    );
  const [productCommissionValidation, setProductCommissionValidation] =
    React.useState([]);

  const [productBonusFormData, setProductBonusFormData] = React.useState(
    Array(0).fill({
      productIds: [],
    })
  );
  const [productBonusValidation, setProductBonusValidation] = React.useState(
    []
  );

  const [bonusFormData, setBonusFormData] = React.useState({
    bounsAmount: null,
  });
  const [mutiLocationFormData, setMutiLocationFormData] = React.useState({
    promoter: [],
  });
  const [onShiftFormData, setOnShiftFormData] = React.useState({
    promoter: [],
  });
  const [bonusValidation, setBonusValidation] = React.useState([]);

  const [transferFromData, setTransferFromData] = React.useState(
    Array(0).fill({
      transferAmount: null,
    })
  );

  const [specialShiftFromData, setSpecialShiftFromData] = React.useState([]);

  const [
    transferProductCommissionsFromData,
    setTransferProductCommissionsFromData,
  ] = React.useState(
    Array(0).fill({
      transferQty: null,
    })
  );

  const [transferValidation, setTransferValidation] = React.useState([]);
  const [specialShiftValidation, setSpecialShiftValidation] = React.useState(
    []
  );

  const [
    transfeProductCommissionsValidation,
    setTransfeProductCommissionsValidation,
  ] = React.useState([]);
  const [adjustmentFromData, setAdjustmentFromData] = React.useState(
    Array(0).fill({
      adjustAmount: null,
    })
  );
  const [adjustmentValidation, setAdjustmentValidation] = React.useState([]);
  const [currentDate, setCurrentDate] = React.useState(null);
  const [productOptions, setProductOptions] = React.useState([]);
  const [promoterOptions, setPromoterOptions] = React.useState([]);
  const [promoterSelectionList, setPromoterSelectionList] = React.useState([]);

  const location = useLocation();
  const mode = location?.state?.mode;
  const disabled = mode === "view" || !mode;
  const fetch = async () => {
    if (id) {
      const { data: setting } = await getSettingById(id);
      if (setting) {
        setCommissionLevelFormData(setting.sales_commission);
        if (!_.isEmpty(setting.special_sales_commission)) {
          setSpecialCommissionLevelFormData(setting.special_sales_commission);
        }
        const convertProductCommission = [];
        _.forEach(setting.products_commission, (products_commission) => {
          _.forEach(products_commission.requirement, (requirement, index) => {
            convertProductCommission.push({
              startDate: products_commission.startDate,
              endDate: products_commission.endDate,
              productIds: products_commission.productIds ?? [],
              excludeCommission: products_commission.excludeCommission,
              isDirectSales: products_commission.isDirectSales,
              commission: requirement.commission,
              name: requirement.name,
              minQty: requirement.minQty,
              maxQty: requirement.maxQty,
              isDisabled: index > 0,
            });
          });
        });
        setProductCommissionFormData(convertProductCommission);
        const convertProductBonus = [];
        _.forEach(setting.product_bouns, (product_bouns) => {
          _.forEach(product_bouns.requirement, (requirement, index) => {
            convertProductBonus.push({
              startDate: product_bouns.startDate,
              endDate: product_bouns.endDate,
              productIds: product_bouns.productIds ?? [],
              currentQty: product_bouns.currentQty,
              bouns: requirement.bouns,
              name: requirement.name,
              minQty: requirement.minQty,
              maxQty: requirement.maxQty,
              isDisabled: index > 0,
            });
          });
        });
        setProductBonusFormData(convertProductBonus);
        setBonusFormData(setting.bouns);
        setTransferFromData(setting.transfer);
        setSpecialShiftFromData(setting.special_shift);
        setMutiLocationFormData({ promoter: setting.muti_location });
        setOnShiftFormData({ promoter: setting.on_shift });
        setTransferProductCommissionsFromData(
          setting.transfer_product_commissions
        );
        setAdjustmentFromData(setting.adjustment);
        setCurrentDate(setting.date);
      }
    } else {
      setCurrentDate(location.state.date);
    }
    const { data: promoters } = await getAllPromoter(true);
    const { data: products } = await getProducts(true);
    const formattedPromoterOptions = _.map(promoters, (promoter) => {
      return {
        label: `${promoter.alias} (${promoter.staff_code})`,
        value: String(promoter.id),
        staff_code: promoter.staff_code,
      };
    });
    const newData = promoters.sort((a, b) =>
      a.work_location[0].districts.localeCompare(b.work_location[0].districts)
    );
    setPromoterSelectionList(newData);
    setPromoterOptions(_.sortBy(formattedPromoterOptions, "staff_code"));

    setProductOptions(products);
    setSlideTranOn(true);
  };

  const createCommissionLevelFormData = () => {
    const cloneRow = [...commissionLevelFormData];
    cloneRow.push({});
    setCommissionLevelFormData(cloneRow);
  };

  const createSpecialCommissionLevelFormData = () => {
    const cloneRow = [...specialCommissionLevelFormData.schmea];
    cloneRow.push({});
    setSpecialCommissionLevelFormData({
      promoter: specialCommissionLevelFormData.promoter,
      schmea: cloneRow,
    });
  };

  const createProductCommissionFormData = () => {
    const cloneRow = [...productCommissionFormData];
    cloneRow.push({
      startDate: moment(currentDate),
      endDate: moment(currentDate).endOf("month"),
      excludeCommission: false,
      isDirectSales: false,
      minQty: -999,
    });
    setProductCommissionFormData(cloneRow);
  };
  const copyProductCommissionFormData = (item, index) => {
    const cloneRow = [...productCommissionFormData];
    cloneRow.splice(index + 1, 0, {
      ...item,
      minQty: parseInt(item.maxQty) + 1,
      name: "",
      maxQty: 0,
      isDisabled: true,
    });
    setProductCommissionFormData(cloneRow);
  };
  const createProductBonusFormData = () => {
    const cloneRow = [...productBonusFormData];
    cloneRow.push({
      currentQty: 0,
      startDate: moment(currentDate),
      endDate: moment(currentDate).endOf("month"),
    });
    setProductBonusFormData(cloneRow);
  };
  const createSpecialShiftForm = () => {
    const cloneRow = [...specialShiftFromData];
    cloneRow.push({
      date: moment(currentDate),
      roster: "FULL",
      rosterString: "",
      key: specialShiftFromData.length + 1,
    });
    setSpecialShiftFromData(cloneRow);
  };
  const createTransferFromData = () => {
    const cloneRow = [...transferFromData];
    cloneRow.push({
      date: moment(currentDate),
      transferAmount: null,
      roster: "FULL",
      rosterString: "",
      key: transferFromData.length + 1,
    });
    setTransferFromData(cloneRow);
  };
  const createTransferProductCommissionsFromData = () => {
    const cloneRow = [...transferProductCommissionsFromData];
    cloneRow.push({
      date: moment(currentDate),
      transferQty: null,
      roster: "FULL",
      rosterString: "",
      key: transferFromData.length + 1,
    });
    setTransferProductCommissionsFromData(cloneRow);
  };
  const createAdjustmentFromData = () => {
    const cloneRow = [...adjustmentFromData];
    cloneRow.push({
      adjustAmount: null,
      date: moment(currentDate).format("YYYY-MM-DD"),
      remark: null,
      qty: 1,
      key: adjustmentFromData.length + 1,
    });
    setAdjustmentFromData(cloneRow);
  };

  const copyProductBonusFormData = (item, index) => {
    const cloneRow = [...productBonusFormData];
    cloneRow.splice(index + 1, 0, {
      ...item,
      minQty: parseInt(item.maxQty) + 1,
      maxQty: 0,
      name: "",
      isDisabled: true,
    });
    setProductBonusFormData(cloneRow);
  };

  const removeCommissionLevelFormData = (index) => {
    const newRow = commissionLevelFormData.filter((row, i) => index !== i);
    setCommissionLevelFormData(newRow);
  };
  const removeSpecialCommissionLevelFormData = (index) => {
    const newRow = specialCommissionLevelFormData.schmea.filter(
      (row, i) => index !== i
    );
    setSpecialCommissionLevelFormData({
      promoter: specialCommissionLevelFormData.promoter,
      schmea: newRow,
    });
  };
  const removeProductCommissionFormData = (index) => {
    const newRow = productCommissionFormData.filter((row, i) => index !== i);
    setProductCommissionFormData(newRow);
  };
  const removeProductBonusFormData = (index) => {
    const newRow = productBonusFormData.filter((row, i) => index !== i);
    setProductBonusFormData(newRow);
  };
  const removeSpecialShiftForm = (index) => {
    const newRow = specialShiftFromData.filter((row, i) => index !== i);
    setSpecialShiftFromData(newRow);
  };
  const removeTransferFromData = (index) => {
    const newRow = transferFromData.filter((row, i) => index !== i);
    setTransferFromData(newRow);
  };
  const removeTransferProductCommissionsFromData = (index) => {
    const newRow = transferProductCommissionsFromData.filter(
      (row, i) => index !== i
    );
    setTransferProductCommissionsFromData(newRow);
  };
  const removeAdjustmentFromData = (index) => {
    const newRow = adjustmentFromData.filter((row, i) => index !== i);
    setAdjustmentFromData(newRow);
  };

  const handleOnClickSave = async () => {
    const groupProductCommissionFormDatas = _.groupBy(
      productCommissionFormData,
      (r) =>
        `${r.startDate}${r.endDate}${r.productIds.join(",")}${
          r.excludeCommission
        }`
    );
    const groupProductBonusFormDats = _.groupBy(
      productBonusFormData,
      (r) => `${r.startDate}${r.endDate}${r.productIds.join(",")}`
    );
    const commissionLevelFormErr = commissionLevelFormData.map(
      (item, index, arr) => {
        let amountErr = "";
        let percentageErr = "";

        const func1 = () => {
          if (item.amount === null) {
            amountErr = "不能為空值";
          }
          if (!item.percentage) {
            percentageErr = "不能為空值";
          }
          return amountErr || percentageErr;
        };

        const func2 = () => {
          if (isNaN(parseInt(item.amount))) {
            amountErr = "必須為數值";
          }
          if (isNaN(parseInt(item.percentage))) {
            percentageErr = "必須為數值";
          }

          return amountErr || percentageErr;
        };

        func1();
        func2();

        return { amountErr, percentageErr };
      }
    );
    const specialCommissionLevelFormErr =
      specialCommissionLevelFormData.schmea.map((item, index, arr) => {
        let amountErr = "";
        let percentageErr = "";

        const func1 = () => {
          if (item.amount === null) {
            amountErr = "不能為空值";
          }
          if (!item.percentage) {
            percentageErr = "不能為空值";
          }
          return amountErr || percentageErr;
        };

        const func2 = () => {
          if (isNaN(parseInt(item.amount))) {
            amountErr = "必須為數值";
          }
          if (isNaN(parseInt(item.percentage))) {
            percentageErr = "必須為數值";
          }

          return amountErr || percentageErr;
        };

        func1();
        func2();

        return { amountErr, percentageErr };
      });
    const productCommissionFormErr = productCommissionFormData.map(
      (item, index, arr) => {
        const obj = {
          startDateErr: "",
          endDateErr: "",
          productIdsErr: "",
          commissionErr: "",
          minQtyErr: "",
          maxQtyErr: "",
          nameErr: "",
        };

        const func1 = () => {
          [
            "startDate",
            "endDate",
            "productIds",
            "commission",
            "minQty",
            "maxQty",
            "name",
          ].forEach((key) => {
            if (item[key] === null || item[key] === "") {
              obj[`${key}Err`] = "不能為空值";
            }
          });

          if (parseInt(item["minQty"]) >= parseInt(item["maxQty"])) {
            obj[`minQtyErr`] = "必須小於最多目標數量";
            obj[`maxQtyErr`] = "必須大於最少目標數量";
          }
          return Object.values(obj).some((item) => item && true);
        };
        const func2 = () => {
          if (isNaN(parseInt(item.commission))) {
            obj.commissionErr = "必須為數值";
          }
          if (
            parseInt(item.maxQty) <= parseInt(item.minQty) &&
            parseInt(item.maxQty) !== 0
          ) {
            obj.maxQtyErr = "必須大於最少目標數量";
          }
          return obj.commissionErr || obj.minQtyErr || obj.maxQtyErr;
        };

        const func3 = () => {
          if (item.startDate > item.endDate) {
            obj.startDateErr = `不能大於${item?.endDate}`;
          }
          return obj.startDateErr;
        };

        func1();
        func2();
        func3();

        return obj;
      }
    );
    _.forEach(
      groupProductCommissionFormDatas,
      (groupProductCommissionFormData) => {
        if (groupProductCommissionFormData.length > 1) {
          let lastQty = groupProductCommissionFormData[0].maxQty;
          _.forEach(groupProductCommissionFormData, (data, index) => {
            if (index === 0) return;
            if (lastQty >= parseInt(data.minQty)) {
              const errIndex = _.findIndex(
                productCommissionFormData,
                (p) =>
                  p.startDate === data.startDate &&
                  p.endDate === data.endDate &&
                  p.productIds === data.productIds &&
                  p.commission === data.commission
              );
              productCommissionFormErr[errIndex].minQtyErr =
                "必須大於上一層的最多目標數";
              productCommissionFormErr[errIndex - 1].maxQtyErr =
                "必須大於下一層的最少目標數";
            }
            lastQty = parseInt(data.maxQty);
          });
        }
      }
    );

    const productBonusFormErr = productBonusFormData.map((item, index, arr) => {
      const obj = {
        startDateErr: "",
        endDateErr: "",
        productIdsErr: "",
        bounsErr: "",
        minQtyErr: "",
        maxQtyErr: "",
        nameErr: "",
      };

      const func1 = () => {
        [
          "startDate",
          "endDate",
          "productIds",
          "commission",
          "minQty",
          "maxQty",
          "bouns",
          "name",
        ].forEach((key) => {
          if (item[key] === null || item[key] === "") {
            obj[`${key}Err`] = "不能為空值";
          }
        });

        if (parseInt(item["minQty"]) >= parseInt(item["maxQty"])) {
          obj[`minQtyErr`] = "必須小於最多目標數量";
          obj[`maxQtyErr`] = "必須大於最少目標數量";
        }
        return Object.values(obj).some((item) => item && true);
      };

      const func2 = () => {
        if (isNaN(parseInt(item.bouns))) {
          obj.bounsErr = "必須為數值";
        }

        if (isNaN(parseInt(item.minQty))) {
          obj.minQtyErr = "必須為數值";
        }
        if (isNaN(parseInt(item.maxQty))) {
          obj.maxQtyErr = "必須為數值";
        }

        if (
          parseInt(item.maxQty) <= parseInt(item.minQty) &&
          parseInt(item.maxQty) !== 0
        ) {
          obj.maxQtyErr = "必須大於最少目標數量";
        }
        return obj.bounsErr || obj.minQtyErr || obj.maxQtyErr;
      };

      const func3 = () => {
        if (item.startDate > item.endDate) {
          obj.startDateErr = `不能大於${item.endDate}`;
        }
        return obj.startDateErr;
      };

      func1();
      func2();
      func3();

      return obj;
    });

    _.forEach(groupProductBonusFormDats, (groupProductBonusFormDat) => {
      if (groupProductBonusFormDat.length > 1) {
        let lastQty = groupProductBonusFormDat[0].maxQty;
        _.forEach(groupProductBonusFormDat, (data, index) => {
          if (index === 0) return;
          if (lastQty >= parseInt(data.minQty)) {
            const errIndex = _.findIndex(
              productBonusFormData,
              (p) =>
                p.startDate === data.startDate &&
                p.endDate === data.endDate &&
                p.productIds === data.productIds &&
                p.bouns === data.bouns
            );
            productBonusFormErr[errIndex].minQtyErr =
              "必須大於上一層的最多目標數";
            productBonusFormErr[errIndex - 1].maxQtyErr =
              "必須大於下一層的最少目標數";
          }
          lastQty = parseInt(data.maxQty);
        });
      }
    });
    const bonusFormErr = {
      bounsAmountErr: bonusFormData.bounsAmount === null ? "必須為數值" : "",
    };
    const transferFromErr = transferFromData.map((item) => {
      const obj = {
        dateErr: "",
        transferAmountErr: "",
      };

      if (
        moment(currentDate).format("YYYY-MM") !==
        moment(item.date).format("YYYY-MM")
      ) {
        obj.dateErr = `日期必需在${moment(currentDate).format("YYYY年MM月內")}`;
      }

      const total = _.sumBy(transferFromData, (r) =>
        parseFloat(r.transferAmount)
      );

      if (total !== 0) {
        obj.transferAmountErr = `總和必須為0，現總和為${total}`;
      }

      return obj;
    });
    const transferProductCommissionsFromErr =
      transferProductCommissionsFromData.map((item) => {
        const obj = {
          dateErr: "",
          transferQtyErr: "",
        };

        if (
          moment(currentDate).format("YYYY-MM") !==
          moment(item.date).format("YYYY-MM")
        ) {
          obj.dateErr = `日期必需在${moment(currentDate).format(
            "YYYY年MM月內"
          )}`;
        }

        const total = _.sumBy(transferProductCommissionsFromData, (r) =>
          parseFloat(r.transferQty)
        );

        if (total !== 0) {
          obj.transferQtyErr = `總和必須為0，現總和為${total}`;
        }

        return obj;
      });
    const adjustFormErr = adjustmentFromData.map((item) => {
      const obj = {
        remarkErr: "",
        adjustAmountErr: "",
      };

      if (!item.remark) {
        obj.remarkErr = `不能為空值`;
      }
      if (!item.adjustAmount) {
        obj.adjustAmountErr = `不能為空值`;
      }
      return obj;
    });
    const isCommissionLevelFormValid = commissionLevelFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.amountErr, cur.percentageErr]),
        []
      )
      .every((item) => item === "");
    const isSpecialCommissionLevelFormValid = specialCommissionLevelFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.amountErr, cur.percentageErr]),
        []
      )
      .every((item) => item === "");
    const isProductCommissionFormValid = productCommissionFormErr
      .reduce(
        (prev, cur) =>
          (prev = [
            ...prev,
            cur.startDateErr,
            cur.endDateErr,
            cur.productIdsErr,
            cur.commissionErr,
            cur.minQtyErr,
            cur.maxQtyErr,
            cur.nameErr,
          ]),
        []
      )
      .every((item) => item === "");

    const isproductBonusValid = productBonusFormErr
      .reduce(
        (prev, cur) =>
          (prev = [
            ...prev,
            cur.startDateErr,
            cur.endDateErr,
            cur.productIdsErr,
            cur.bounsErr,
            cur.minQtyErr,
            cur.maxQtyErr,
            cur.nameErr,
          ]),
        []
      )
      .every((item) => item === "");
    const isBonusFormvalid = !bonusFormErr.bounsAmountErr;
    const isTransferFromvalid = transferFromErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.transferAmountErr, cur.dateErr]),
        []
      )
      .every((item) => item === "");
    const isTransferProductCommissionsFromvalid =
      transferProductCommissionsFromErr
        .reduce(
          (prev, cur) => (prev = [...prev, cur.transferQtyErr, cur.dateErr]),
          []
        )
        .every((item) => item === "");
    const isAdjustFormValid = adjustFormErr
      .reduce(
        (prev, cur) => (prev = [...prev, cur.remarkErr, cur.adjustAmountErr]),
        []
      )
      .every((item) => item === "");
    if (
      !isCommissionLevelFormValid ||
      !isSpecialCommissionLevelFormValid ||
      !isProductCommissionFormValid ||
      !isproductBonusValid ||
      !isBonusFormvalid ||
      !isTransferFromvalid ||
      !isTransferProductCommissionsFromvalid ||
      !isAdjustFormValid
    ) {
      setSnackMessage(`更新失敗，請填寫所有資料`);
      setSnackOpen(true);
      setSnackSeverity("error");
      setCommissionLevelValidation(commissionLevelFormErr);
      setSpecialCommissionLevelValidation(specialCommissionLevelFormErr);
      setProductCommissionValidation(productCommissionFormErr);
      setProductBonusValidation(productBonusFormErr);
      setBonusValidation(bonusFormErr);
      setTransferValidation(transferFromErr);
      setTransfeProductCommissionsValidation(transferProductCommissionsFromErr);
      setAdjustmentValidation(adjustFormErr);
      return false;
    } else {
      try {
        const convertProductCommissionFormData = [];
        _.forEach(groupProductCommissionFormDatas, (rows) => {
          const {
            endDate,
            productIds,
            startDate,
            excludeCommission,
            isDirectSales,
          } = rows[0];
          const requirement = [];
          _.forEach(rows, (row) => {
            requirement.push({
              maxQty: row.maxQty,
              minQty: row.minQty,
              commission: row.commission,
              name: row.name,
            });
          });
          convertProductCommissionFormData.push({
            isDirectSales,
            excludeCommission,
            productIds,
            endDate,
            startDate,
            requirement,
          });
        });

        const convertProductBonusFormData = [];
        _.forEach(groupProductBonusFormDats, (rows) => {
          const { endDate, productIds, startDate, currentQty } = rows[0];
          const requirement = [];
          _.forEach(rows, (row) => {
            requirement.push({
              maxQty: row.maxQty,
              minQty: row.minQty,
              bouns: row.bouns,
              name: row.name,
            });
          });
          convertProductBonusFormData.push({
            productIds,
            endDate,
            startDate,
            currentQty,
            requirement,
          });
        });
        const reqBody = {
          sales_commission: commissionLevelFormData,
          special_sales_commission: specialCommissionLevelFormData,
          products_commission: convertProductCommissionFormData,
          adjustment: adjustmentFromData,
          product_bouns: convertProductBonusFormData,
          muti_location: mutiLocationFormData.promoter,
          bouns: bonusFormData,
          on_shift: onShiftFormData.promoter,
          special_shift: specialShiftFromData,
          transfer: transferFromData,
          transfer_product_commissions: transferProductCommissionsFromData,
          date: moment(currentDate).format("YYYY-MM-01"),
        };
        if (id) {
          await updateSetting(id, reqBody);
        } else {
          await createSetting(reqBody);
        }
        setSnackSeverity("success");
        setSnackMessage(`更新成功,請重新計算佣金`);
        setSnackOpen(true);
        setCommissionLevelValidation({});
        setProductCommissionValidation({});
        setProductBonusValidation({});
        setBonusValidation({});
        setSpecialShiftValidation([]);
        setTransferValidation({});
        setTransfeProductCommissionsValidation({});
      } catch (error) {
        setSnackMessage(`更新失敗`);
        setSnackSeverity("error");
      } finally {
        setSnackOpen(true);
      }
    }
  };
  const handleCommissionLevelForm = (position, data) => {
    const cloneRow = [...commissionLevelFormData];
    const updatedValue = cloneRow.map((item, index) => {
      if (position === index) {
        const key = Object.keys(data)[0];
        item = { ...item, [key]: Object.values(data)[0] };
      }
      return item;
    });
    setCommissionLevelFormData(updatedValue);
  };

  const handleSpecialCommissionLevelForm = (position, data) => {
    const cloneRow = [...specialCommissionLevelFormData.schmea];
    const updatedValue = cloneRow.map((item, index) => {
      if (position === index) {
        const key = Object.keys(data)[0];
        item = { ...item, [key]: Object.values(data)[0] };
      }
      return item;
    });
    setSpecialCommissionLevelFormData({
      promoter: specialCommissionLevelFormData.promoter,
      schmea: updatedValue,
    });
  };
  const handleProductCommissionForm = (position, key, value) => {
    const cloneRow = [...productCommissionFormData];
    if (
      [
        "startDate",
        "endDate",
        "productIds",
        "isDirectSales",
        "excludeCommission",
      ].includes(key)
    ) {
      _.forEach(productCommissionFormData, (data, index) => {
        if (
          data.startDate === cloneRow[position].startDate &&
          data.endDate === cloneRow[position].endDate &&
          data.productIds === cloneRow[position].productIds &&
          index !== position
        ) {
          cloneRow[index][key] = value;
        }
      });
    }
    cloneRow[position][key] = value;

    setProductCommissionFormData(cloneRow);
  };
  const handleProductBonusForm = (position, key, value) => {
    const cloneRow = [...productBonusFormData];
    if (["startDate", "endDate", "productIds"].includes(key)) {
      _.forEach(productBonusFormData, (data, index) => {
        if (
          data.startDate === cloneRow[position].startDate &&
          data.endDate === cloneRow[position].endDate &&
          data.productIds === cloneRow[position].productIds &&
          index !== position
        ) {
          cloneRow[index][key] = value;
        }
      });
    }

    cloneRow[position][key] = value;

    setProductBonusFormData(cloneRow);
  };

  const handleBonusFrom = (field, data) => {
    setBonusFormData((prev) => {
      return {
        ...prev,
        [field]: data,
      };
    });
  };
  const handleRoster = async (cloneRow, position, value, date) => {
    const { data: roster } = await getRosterByUserIdAndDate(value, date);
    let rosterString = "";
    let location_id = "";
    if (!roster) {
      rosterString = "";
    } else if (roster.is_off) {
      rosterString = roster.off_type;
    } else if (roster.is_leave) {
      rosterString = roster.leave_type;
    } else {
      if (roster.roster === "FULL") {
        rosterString = `${roster.work_name} - 全日更`;
      } else {
        rosterString = `${roster.work_name} - ${roster.roster}更`;
      }
      location_id = roster.location_id;
    }
    cloneRow[position].rosterString = rosterString;
    cloneRow[position].location_id = location_id;
    return cloneRow;
  };
  const handleSpecialShiftForm = async (position, key, value) => {
    let cloneRow = [...specialShiftFromData];
    cloneRow[position][key] = value;
    if (cloneRow[position]["user"] && cloneRow[position].date) {
      cloneRow = await handleRoster(
        cloneRow,
        position,
        cloneRow[position]["user"].value,
        cloneRow[position].date
      );
    } else {
      cloneRow[position].rosterString = "";
    }

    setSpecialShiftFromData(cloneRow);
  };
  const handleTransferFrom = async (position, key, value) => {
    let cloneRow = [...transferFromData];
    cloneRow[position][key] = value;
    if (cloneRow[position]["transferUser"] && cloneRow[position].date) {
      cloneRow = await handleRoster(
        cloneRow,
        position,
        cloneRow[position]["transferUser"].value,
        cloneRow[position].date
      );
    } else {
      cloneRow[position].rosterString = "";
    }
    setTransferFromData(cloneRow);
  };
  const handleTransferProductCommissionsFrom = async (position, key, value) => {
    let cloneRow = [...transferProductCommissionsFromData];
    cloneRow[position][key] = value;
    if (cloneRow[position]["transferUser"] && cloneRow[position].date) {
      cloneRow = await handleRoster(
        cloneRow,
        position,
        cloneRow[position]["transferUser"].value,
        cloneRow[position].date
      );
    } else {
      cloneRow[position].rosterString = "";
    }
    setTransferProductCommissionsFromData(cloneRow);
  };
  const handleAdjustmentFrom = (position, key, value) => {
    const cloneRow = [...adjustmentFromData];
    cloneRow[position][key] = value;

    setAdjustmentFromData(cloneRow);
  };
  const commissionLevelFormObj = {
    commissionLevelFormData,
    createCommissionLevelFormData,
    handleCommissionLevelForm,
    commissionLevelValidation,
    removeCommissionLevelFormData,
    disabled,
  };
  const specialCommissionLevelFormObj = {
    specialCommissionLevelFormData,
    setSpecialCommissionLevelFormData,
    createSpecialCommissionLevelFormData,
    handleSpecialCommissionLevelForm,
    specialCommissionLevelValidation,
    removeSpecialCommissionLevelFormData,
    promoterSelectionList,
    disabled,
  };
  const productCommissionsFormObj = {
    productCommissionFormData,
    createProductCommissionFormData,
    handleProductCommissionForm,
    productCommissionValidation,
    productOptions,
    disabled,
    copyProductCommissionFormData,
    removeProductCommissionFormData,
    currentDate,
  };
  const productBonusFormObj = {
    productBonusFormData,
    createProductBonusFormData,
    handleProductBonusForm,
    productBonusValidation,
    productOptions,
    disabled,
    copyProductBonusFormData,
    removeProductBonusFormData,
    currentDate,
  };
  const specialShiftFormObj = {
    specialShiftFromData,
    handleSpecialShiftForm,
    specialShiftValidation,
    disabled,
    promoterOptions,
    createSpecialShiftForm,
    removeSpecialShiftForm,
    currentDate,
  };
  const onShiftFormObj = {
    onShiftFormData,
    setOnShiftFormData,
    promoterSelectionList,
  };
  const mutiLocationFormObj = {
    mutiLocationFormData,
    setMutiLocationFormData,
    promoterSelectionList,
  };
  const bonusFormObj = {
    bonusFormData,
    handleBonusFrom,
    bonusValidation,
    disabled,
  };
  const transferFormObj = {
    transferFromData,
    handleTransferFrom,
    transferValidation,
    disabled,
    promoterOptions,
    createTransferFromData,
    removeTransferFromData,
    currentDate,
  };
  const transferProductCommissionsFormObj = {
    transferProductCommissionsFromData,
    handleTransferProductCommissionsFrom,
    transfeProductCommissionsValidation,
    disabled,
    promoterOptions,
    createTransferProductCommissionsFromData,
    removeTransferProductCommissionsFromData,
    productOptions,
    currentDate,
  };
  const ajustmentFormObj = {
    adjustmentFromData,
    handleAdjustmentFrom,
    adjustmentValidation,
    disabled,
    promoterOptions,
    productOptions,
    createAdjustmentFromData,
    removeAdjustmentFromData,
  };
  const arrForm = [
    {
      name: "commissionLevelForm",
      title: "佣金百份比(預設)",
      tooltip:
        "如果沒有上限，請於最後一層輸入一個無限大銷售金額 例$9,999,999,999",
      component: <CommissionLevelForm {...commissionLevelFormObj} />,
    },
    {
      name: "specialComissionLevelForm",
      title: "兼職佣金百份比",
      tooltip: `如無設定兼職員工將會以預設佣金計算
        如果沒有上限，請於最後一層輸入一個無限大銷售金額 例$9,999,999,999`,
      component: (
        <SpecialComissionLevelForm {...specialCommissionLevelFormObj} />
      ),
    },
    {
      name: "productCommissionsForm",
      title: "盒仔佣",
      tooltip: `如勾選了「不計入佣金」該時段的銷售額將不計入佣金
      如勾選了「Direct Sales」該產品會以Direct Sales的銷售額作出計算盒仔佣
      如需要分層計算,請按下複製按鈕並設定每層的名稱，最少／最多目標數量和佣金
      如果沒有上限，請於最後一層的「最多目標數量」輸入一個無限大件數 例999,999,999`,
      component: <ProductCommissionsForm {...productCommissionsFormObj} />,
    },
    {
      name: "productBonusForm",
      title: "產品獎金",
      tooltip: `如需要分層計算,請按下複製按鈕並設定每層的名稱，最少／最多目標數量和獎金金額
      如果沒有上限，請於最後一層的「最多目標數量」輸入一個無限大件數 例999,999,999
      如橫跨多個月份計算，請於最後一個月份設定 例如2025-01-22至2025-02-10，請在2月才計算`,
      component: <ProductBonusForm {...productBonusFormObj} />,
    },
    {
      name: "bonusForm",
      title: "到數獎金",
      tooltip: "設定到數獎金",
      component: <BonusForm {...bonusFormObj} />,
    },
    {
      name: "onShiftForm",
      title: "A/B更設定",
      tooltip: `該銷售員的銷售數總數除以當天的更數，
      例如KZ鋪於${moment(currentDate).format("YYYY-MM-DD")}有2更(A更和B更) 
      當天的銷售數為$100,000 每人會有$100,000 / 2 = $50,000
      反之如果當日並沒有其他更，$100,000會全數歸入該銷售員。`,
      component: <OnShiftForm {...onShiftFormObj} />,
    },
    {
      name: "specialShiftForm",
      title: "特別更設定",
      tooltip: `如設定為特別更，該銷售員當天的銷售數，盒仔佣將不作計算，
      如同日該鋪頭有其他非特別更的銷售員，將會全數歸入該銷售員`,
      component: <SpecialShiftForm {...specialShiftFormObj} />,
    },
    {
      name: "mutiLocationForm",
      title: "走場設定",
      tooltip: `如設定為走場，該銷售員的目標銷售額會根據當天的鋪頭的目標銷售數設定，
      例如KZ鋪於${moment(currentDate).format(
        "YYYY年M月"
      )}的目標銷售額為$1,000,000, 
      走場銷售員在KZ鋪頭每天目標銷售數為$1,000,000 / 30(該月總日數) = $33,333.3`,
      component: <MutiLocationForm {...mutiLocationFormObj} />,
    },
    {
      name: "transferForm",
      title: "調整銷售金額(轉換)",
      tooltip: `金額總和必須為$0`,
      component: <TransferForm {...transferFormObj} />,
    },
    {
      name: "transferProductCommissionsForm",
      title: "調整盒仔佣(轉換)",
      tooltip: `件數總和必須為$0`,
      component: (
        <TransferProductCommissionsForm
          {...transferProductCommissionsFormObj}
        />
      ),
    },
    {
      name: "adjustmentForm",
      title: "最後調整",
      tooltip: `任意調整，必須輸入備註`,
      component: <AdjustmentForm {...ajustmentFormObj} />,
    },
  ];

  const muiAccordion = (forms) => (
    <ThemeProvider theme={CommissionManageTheme}>
      <Container>
        {forms.map(({ title, component, tooltip }, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>
                {title}
                {tooltip && (
                  <CustomWidthTooltip
                    sx={{ whiteSpace: "pre-line" }}
                    title={
                      <span
                        style={{ whiteSpace: "pre-line", fontSize: "14px" }}
                      >
                        {tooltip}
                      </span>
                    }
                    placement="right-end"
                  >
                    <IconButton>
                      <InfoOutlinedIcon />
                    </IconButton>
                  </CustomWidthTooltip>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>{component}</AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </ThemeProvider>
  );
  React.useEffect(() => {
    fetch();
  }, []);
  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`佣金設定（${moment(currentDate).format("YYYY年M月")}）`}
        history={() => navigate(-1)}
        children={
          !disabled ? (
            <div>
              {/* Save Record */}
              <IconButton component="label" onClick={handleOnClickSave}>
                <SaveIcon />
              </IconButton>
            </div>
          ) : null
        }
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>{muiAccordion(arrForm)}</StyledPaper>
      </Fade>
    </Layout>
  );
};

export default CommissionSettingPage;

const CommissionLevelForm = React.memo(function CommissionLevelForm({
  commissionLevelFormData,
  createCommissionLevelFormData,
  handleCommissionLevelForm,
  commissionLevelValidation,
  removeCommissionLevelFormData,
  disabled,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createCommissionLevelFormData}>
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        {commissionLevelFormData?.map((item, index) => {
          return (
            <CommissionLevelFormRow
              item={item}
              index={index}
              handleCommissionLevelForm={handleCommissionLevelForm}
              commissionLevelValidation={commissionLevelValidation}
              removeCommissionLevelFormData={removeCommissionLevelFormData}
              disabled={disabled}
            />
          );
        })}
      </Box>
    </React.Fragment>
  );
});

const SpecialComissionLevelForm = React.memo(
  function SpecialComissionLevelForm({
    setSpecialCommissionLevelFormData,
    specialCommissionLevelFormData,
    createSpecialCommissionLevelFormData,
    handleSpecialCommissionLevelForm,
    specialCommissionLevelValidation,
    removeSpecialCommissionLevelFormData,
    disabled,
    promoterSelectionList,
  }) {
    return (
      <React.Fragment>
        <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
          <SpecialComissionLevelFormRow
            createSpecialCommissionLevelFormData={
              createSpecialCommissionLevelFormData
            }
            staffOptions={promoterSelectionList}
            setSpecialCommissionLevelFormData={
              setSpecialCommissionLevelFormData
            }
            specialCommissionLevelFormData={specialCommissionLevelFormData}
            handleSpecialCommissionLevelForm={handleSpecialCommissionLevelForm}
            specialCommissionLevelValidation={specialCommissionLevelValidation}
            removeSpecialCommissionLevelFormData={
              removeSpecialCommissionLevelFormData
            }
            disabled={disabled}
          />
        </Box>
      </React.Fragment>
    );
  }
);
const ProductCommissionsForm = React.memo(function ProductCommissionsForm({
  productCommissionFormData,
  createProductCommissionFormData,
  handleProductCommissionForm,
  productCommissionValidation,
  productOptions,
  disabled,
  copyProductCommissionFormData,
  removeProductCommissionFormData,
  currentDate,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton
            component="label"
            onClick={createProductCommissionFormData}
          >
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={2} sx={{ paddingX: 1 }}>
        {productCommissionFormData.map((item, index) => (
          <ProductCommissionFormRow
            item={item}
            index={index}
            handleProductCommissionForm={handleProductCommissionForm}
            productCommissionValidation={productCommissionValidation}
            productOptions={productOptions}
            disabled={disabled}
            copyProductCommissionFormData={copyProductCommissionFormData}
            removeProductCommissionFormData={removeProductCommissionFormData}
            currentDate={currentDate}
          />
        ))}
      </Box>
    </React.Fragment>
  );
});

const ProductBonusForm = React.memo(function ProductBonusForm({
  productBonusFormData,
  createProductBonusFormData,
  handleProductBonusForm,
  productBonusValidation,
  productOptions,
  disabled,
  copyProductBonusFormData,
  removeProductBonusFormData,
  currentDate,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createProductBonusFormData}>
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={1} sx={{ paddingX: 1 }}>
        {productBonusFormData.map((item, index) => (
          <ProductBonusFormRow
            item={item}
            index={index}
            handleProductBonusForm={handleProductBonusForm}
            productBonusValidation={productBonusValidation}
            productOptions={productOptions}
            disabled={disabled}
            copyProductBonusFormData={copyProductBonusFormData}
            removeProductBonusFormData={removeProductBonusFormData}
            currentDate={currentDate}
          />
        ))}
      </Box>
    </React.Fragment>
  );
});

const OnShiftForm = React.memo(function BonusForm({
  onShiftFormData,
  setOnShiftFormData,
  promoterSelectionList,
}) {
  return (
    <OnShiftFormRow
      onShiftFormData={onShiftFormData}
      setOnShiftFormData={setOnShiftFormData}
      staffOptions={promoterSelectionList}
    />
  );
});
const MutiLocationForm = React.memo(function BonusForm({
  mutiLocationFormData,
  setMutiLocationFormData,
  promoterSelectionList,
}) {
  return (
    <MutiLocationFormRow
      mutiLocationFormData={mutiLocationFormData}
      setMutiLocationFormData={setMutiLocationFormData}
      staffOptions={promoterSelectionList}
    />
  );
});

const BonusForm = React.memo(function BonusForm({
  bonusFormData,
  handleBonusFrom,
  bonusValidation,
  disabled,
}) {
  return (
    <BonusFormRow
      bonusFormData={bonusFormData}
      handleBonusFrom={handleBonusFrom}
      bonusValidation={bonusValidation}
      disabled={disabled}
    />
  );
});

const TransferProductCommissionsForm = React.memo(
  function TransferProductCommissionsForm({
    transferProductCommissionsFromData,
    handleTransferProductCommissionsFrom,
    transfeProductCommissionsValidation,
    disabled,
    promoterOptions,
    createTransferProductCommissionsFromData,
    removeTransferProductCommissionsFromData,
    productOptions,
    currentDate,
  }) {
    return (
      <React.Fragment>
        {!disabled && (
          <Box>
            <IconButton
              component="label"
              onClick={createTransferProductCommissionsFromData}
            >
              <AddOutlinedIcon />
            </IconButton>
          </Box>
        )}
        <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
          {transferProductCommissionsFromData.map((item, index) => (
            <TransferProductCommissionsFormRow
              item={item}
              index={index}
              productOptions={productOptions}
              handleTransferProductCommissionsFrom={
                handleTransferProductCommissionsFrom
              }
              currentDate={currentDate}
              transfeProductCommissionsValidation={
                transfeProductCommissionsValidation
              }
              disabled={disabled}
              promoterOptions={promoterOptions}
              removeTransferProductCommissionsFromData={
                removeTransferProductCommissionsFromData
              }
            />
          ))}
        </Box>
      </React.Fragment>
    );
  }
);

const SpecialShiftForm = React.memo(function TransferForm({
  specialShiftFromData,
  handleSpecialShiftForm,
  specialShiftValidation,
  disabled,
  promoterOptions,
  createSpecialShiftForm,
  removeSpecialShiftForm,
  currentDate,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createSpecialShiftForm}>
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        {specialShiftFromData.map((item, index) => (
          <SpecialShiftFormRow
            item={item}
            currentDate={currentDate}
            index={index}
            handleSpecialShiftForm={handleSpecialShiftForm}
            specialShiftValidation={specialShiftValidation}
            disabled={disabled}
            promoterOptions={promoterOptions}
            removeSpecialShiftForm={removeSpecialShiftForm}
          />
        ))}
      </Box>
    </React.Fragment>
  );
});

const TransferForm = React.memo(function TransferForm({
  transferFromData,
  handleTransferFrom,
  transferValidation,
  disabled,
  promoterOptions,
  createTransferFromData,
  removeTransferFromData,
  currentDate,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createTransferFromData}>
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        {transferFromData.map((item, index) => (
          <TransferFormRow
            item={item}
            index={index}
            currentDate={currentDate}
            handleTransferFrom={handleTransferFrom}
            transferValidation={transferValidation}
            disabled={disabled}
            promoterOptions={promoterOptions}
            removeTransferFromData={removeTransferFromData}
          />
        ))}
      </Box>
    </React.Fragment>
  );
});

const AdjustmentForm = React.memo(function AdjustmentForm({
  adjustmentFromData,
  handleAdjustmentFrom,
  adjustmentValidation,
  disabled,
  promoterOptions,
  productOptions,
  createAdjustmentFromData,
  removeAdjustmentFromData,
}) {
  return (
    <React.Fragment>
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createAdjustmentFromData}>
            <AddOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        {adjustmentFromData.map((item, index) => (
          <AdjustmentFormRow
            item={item}
            index={index}
            handleAdjustmentFrom={handleAdjustmentFrom}
            adjustmentValidation={adjustmentValidation}
            productOptions={productOptions}
            disabled={disabled}
            promoterOptions={promoterOptions}
            removeAdjustmentFromData={removeAdjustmentFromData}
          />
        ))}
      </Box>
    </React.Fragment>
  );
});
